import { useAuth } from 'common-react/auth/AuthProvider';
import { useMemo } from 'react';

export const useAppUserDetailsFromJwt = <TPermission>(): {
  appUserId?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  permissions?: TPermission[];
} => {
  const { authStoreAccess } = useAuth();
  const jwtToken = authStoreAccess.getJwtToken();

  return useMemo(() => {
    try {
      const isValidJwtToken = jwtToken?.split('.')?.length === 3;
      if (!isValidJwtToken) {
        return {};
      }

      const payload = atob(jwtToken.split('.')[1]);
      const data = JSON.parse(payload);

      return {
        appUserId: data.appUserId ?? data.appClaims?.appUserId,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.subjectEmail,
        permissions: data.appClaims?.permissions,
      };
    } catch (error) {
      return {};
    }
  }, [jwtToken]);
};
